// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"a2402db5","367":"55c16207","886":"b905db92","919":"44e7798d"}[chunkId] + ".chunk.css";
};